import type { BackendSessionPayload } from '../../../backend.d'
import { Accessor, Signal, createRoot, createSignal } from 'solid-js'
import { mountListener } from '../../../lib/event/event'
import { Nullable } from '../../../typescript'
import { getSessionValue, sessionValueUpdatedEvent } from './sessionValue'

export type SessionAccessor = Accessor<Nullable<BackendSessionPayload>>

const sessionSignal: Signal<Nullable<BackendSessionPayload>> = createRoot(() => {
  const val = getSessionValue() as Nullable<BackendSessionPayload>
  // eslint-disable-next-line solid/reactivity
  const signal = createSignal<Nullable<BackendSessionPayload>>(val)
  mountListener(sessionValueUpdatedEvent, signal[1])
  return signal
})

export const getSession = sessionSignal[0]
export const setSignal = sessionSignal[1]
